import { render } from "./SimpleTextCell.vue?vue&type=template&id=52c0d398"
import script from "./SimpleTextCell.vue?vue&type=script&lang=js"
export * from "./SimpleTextCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__